export default __webpack_public_path__ + "static/media/AkhlakhossainJim_logo.6ae9a4af.png";